import { useCallback } from 'react';
import { useNotesToolbarContext } from '../../context/notes/notes_toolbar_context';
import theme from '../../styles/theme';
import { useEditorStateContext } from '../../context/notes/notes_editor_state_context';
import { LINK_BUTTON_SUFFIX } from '../../components/notes/consts';
export const useLinkButton = () => {
    const { captureButtonClick, inCallOrPostCall, readOnlyYn, displayModeYn } = useEditorStateContext();
    const { linkContext } = useNotesToolbarContext();
    const { setModalState, modalState, isExistingLinkYn } = linkContext;
    const isButtonDisabled = readOnlyYn || displayModeYn;
    const iconHoverFillColor = isButtonDisabled ? undefined : theme.colors.blue50;
    const handleClick = useCallback(() => {
        typeof captureButtonClick === 'function' &&
            captureButtonClick(`${inCallOrPostCall}-${LINK_BUTTON_SUFFIX}`);
        setModalState(prev => ({
            ...prev,
            open: true,
        }));
    }, [captureButtonClick, inCallOrPostCall, setModalState]);
    return {
        isButtonDisabled,
        iconHoverFillColor,
        handleClick,
        modalState,
        isExistingLinkYn,
    };
};
//# sourceMappingURL=use_link_button.js.map